var exports = {
  "q": "xaf9ae18d--a0c430--layer",
};

module.exports = exports;
